import { render, staticRenderFns } from "./BirthdayCard.vue?vue&type=template&id=57bf87da&"
import script from "./BirthdayCard.vue?vue&type=script&lang=js&"
export * from "./BirthdayCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports